import React, { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import FileViewer from "react-file-viewer";
import axios from "axios";

function FormModal(props) {
  const [showFile, setShowFile] = useState(false);
  const [linkToFile, setLinkToFile] = useState(null);
  const [downloading, setDownloading] = useState(false);
  console.log(props.data);
  useEffect(() => {
    window.addEventListener("mousemove", () => {
      if (
        document.getElementById("closeFormModalBtn") &&
        window.matchMedia("(min-width: 578px)").matches
      ) {
        document.getElementById("closeFormModalBtn").style.opacity = "1";
        setTimeout(() => {
          if (
            document.getElementById("closeFormModalBtn") &&
            window.matchMedia("(min-width: 578px)").matches
          ) {
            document.getElementById("closeFormModalBtn").style.opacity = "0";
          }
        }, 5000);
      }
    });
  }, []);

  const token = localStorage.getItem("kss_token");
  const getForm = async () => {
    if (token) {
      try {
        const res = await axios.get(
          `https://server.abnca.in/forms/${props.data.APIEndpoint}`,
          {
            headers: {
              token: token,
            },
          }
        );

        if (res.data.fileURL) {
          setLinkToFile(res.data.fileURL);
          setDownloading(false);
          console.log(res.data.fileURL);
          const a = document.createElement("a");
          a.href = res.data.fileURL;
          a.style.display = "none";
          a.setAttribute("download", true);

          a.click();
        } else {
          window.alert(res.data.message);
        }
      } catch (error) {
        setDownloading(false);
        console.log(error.response);
        window.alert(error.response.data.message);
      }
    } else {
      setDownloading(false);
      window.alert("Please login to use this feature");
    }
  };

  // useEffect(() => {
  //   getForm();
  // }, []);

  const type = "docx";

  return (
    <>
      <Modal
        show={props.show}
        onHide={() => props.handleModal(false)}
        animation={true}
        // className="formModal p-0"
      >
        <Modal.Header>
          <Modal.Title className="small">{props.data.name}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="formModalContent">
            <p className="text-center mb-2">Form No: {props.data.formId}</p>
            <p className="text-center m-0">
              {props.data.deadline && (
                <span className="mr-4">Deadline : {props.data.deadline}</span>
              )}
              <span>Form Version : {props.data.uploaded}</span>
            </p>
            <div className="text-center my-3">
              {downloading ? (
                <p className="text-center">Downloading....</p>
              ) : (
                <>
                  {token && (
                    <a
                      href={props.data.file}
                      download
                      className="btn btn-outline-primary mr-2"
                    >
                      Download Empty Form
                    </a>
                  )}
                  {token ? (
                    <button
                      className="btn btn-primary"
                      onClick={() => {
                        getForm();
                        setDownloading(true);
                      }}
                    >
                      Download Autofilled Form
                    </button>
                  ) : (
                    <a href={props.data.file} download className="btn btn-primary">Download Form</a>
                  )}
                </>
              )}
            </div>
          </div>
          {showFile ? (
            <FileViewer fileType={type} filePath={props.data.file} />
          ) : (
            ""
          )}
        </Modal.Body>
      </Modal>
    </>
  );
}

export default FormModal;
